module.exports = __webpack_public_path__ + "img/about-7.84a12224.jpg";